import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {ElementTestId} from '@Tests/tests.types';
import {useAppSelector} from '@/hooks';
import {getPosterDuration} from '@Components/poster-editor/poster-editor-reducer';
import {noop} from '@Utils/general.util';

interface IconPlayPauseProps {
  className?: string;
  size?: IconSize;
  shape?: IconShape;
  type?: IconType;
  onClick?: (shouldPlay: boolean) => void;
  hasMarginRight?: boolean;
}

export function IconPlayPause({
  className = '',
  size = IconSize.SIZE_ICON_20,
  shape = IconShape.CIRCLE,
  onClick = noop,
  type = IconType.SHADOW,
  hasMarginRight = true,
}: IconPlayPauseProps): ReactElement {
  const posterDuration = useAppSelector(getPosterDuration);
  const isPlaying = useAppSelector((state) => {
    return state.posterEditor.isPlaying;
  });
  const currentTime = useAppSelector((state) => {
    return state.posterEditor.currentTime;
  });
  const getIcon = (): string => {
    if (isPlaying) {
      return 'icon-pause';
    }

    if (currentTime === posterDuration) {
      return 'icon-replay-video';
    }

    return 'icon-play-video';
  };

  return (
    <Icon
      onClick={(): void => {
        onClick(!isPlaying);
      }}
      className={`${hasMarginRight ? 'spacing-m-r-2' : ''} ${className}`}
      icon={getIcon()}
      size={size}
      shape={shape}
      type={type}
      data-testid={ElementTestId.POSTER_EDITOR_WEB_BOTTOM_BAR_PLAY_PAUSE_BUTTON}
    />
  );
}
